import { render } from "./ThunderEggP5V2.vue?vue&type=template&id=217f80b8&bindings={\"eggId\":\"props\",\"owner\":\"props\",\"lava\":\"props\",\"lpStones\":\"props\",\"birth\":\"props\",\"name\":\"props\",\"age\":\"props\",\"prefix\":\"props\"}"
import script from "./ThunderEggP5V2.vue?vue&type=script&lang=js"
export * from "./ThunderEggP5V2.vue?vue&type=script&lang=js"
script.render = render

export default script